import React from 'react'

import AddressWithMap from 'components/AddressWithMap'
import SuburbLookup from 'components/Lookups/Suburb'
import Map from 'components/Map'
import LoanAmount from 'components/LoanAmount'

import ContinueButton from 'components/ContinueButton'
import Back from '../commons/Back'
import { capitalizeText } from 'servos/textHelpers'

import {
  getValidatePostcode,
} from 'requesters/postcodes'

class LoanLocation extends React.Component {
  state = {
    errors: {},
    validPostcode: true, // Temporary (default value must be: false)
    coords: {},
    options: [],
    polygonCoords: [],
    loanAmount: this.props.loanAmount,
    spendAmount: '',
    loanRatio: '',
    rentAmount: '',
    continueEnabled: false,
    helpText: '',
    loanAmountValid: false,
  }

  componentDidUpdate(prevProps, prevState) {
    const { options, errors } = this.state

    if (prevState.options === [] || prevState.options !== options) {
      this.renderToMaps(this.state.options)
    }
  }

  onLoanAmountChange = ({loanAmount, spendAmount, rentAmount, loanRatio, loanAmountValid}) => {
    this.setState({
      loanAmount,
      spendAmount,
      rentAmount,
      loanRatio,
      loanAmountValid,
    })
  }

  // ADDRESS AND SUBURB SEARCH
  postcodeValidationSuccess = (data) => {
    let errors = { ...this.state.errors }
    delete errors['postcode'];

    this.setState({
      errors,
      validPostcode: true,
      continueEnabled: true,
    })
  }

  // ADDRESS AND SUBURB SEARCH
  postcodeValidationFailure = (data) => {
    let errors = { ...this.state.errors }
    errors['postcode'] = I18n.t('onboarding.loan_location.errors.postcode')

    this.setState({
      errors,
      validPostcode: false,
      continueEnabled: false,
    })
  }

  // SUBURB SEARCH ONLY
  validatePostcode = (postcode) => {
    getValidatePostcode(
      postcode,
      this.postcodeValidationSuccess,
      this.postcodeValidationFailure
    )
  }

  // SUBURB SEARCH ONLY
  extractPostcode = (address) => {
    let postcode = null
    const regex = /, [0-9][0-9][0-9][0-9],/

    if (address.length > 1) {
      address.forEach((address) => {
        if (address.display_name.match(regex) != null) {
          postcode = address.display_name.match(regex)[0].split(',')[1].trim()
        }
      })
    } else if (address.length === 1) {
      postcode = address[0].display_name.match(regex) ? address[0].display_name.match(regex)[0].split(',')[1].trim() : null
    }
    return postcode
  }

  renderCoordinate(paths){
    const polygonCoords = [];
    let position = 0;
    paths.map((location) =>{
      polygonCoords.push({"lat": location[1], "lng": location[0]});
      position++
      return true;
    });

    this.setState({ polygonCoords });
  }

  // ADDDRESS ONLY
  setAddress = (addressData) => {
    const {
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
      coords,
    } = addressData


    this.setState({
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
      coords,
    })
  }

  isPurchaseAndInvestment() {
    return (this.props.loanPurpose == 'purchase') && (this.props.loanTarget == 'investment')
  }

  onClick = () => {
    const {
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
      spendAmount,
      loanAmount,
      rentAmount,
      loanRatio,
      validPostcode,
      loanAmountValid,
    } = this.state

    if ( validPostcode && loanAmountValid ) {
      this.props.onChoice({
        locationAddress,
        locationSuburb,
        locationPostcode,
        locationState,
        spendAmount,
        loanRatio,
        loanAmount,
        rentAmount,
      })
    }
  }

  // SUBURB SEARCH ONLY
  setPolygon = (metaData) => {
    if (!metaData) { return; }
    if (metaData.locationAddress === undefined) {

      let {
        address_line_1,
        address_line_2,
      } = metaData

      this.setState({
        coords: {},
        polygonCoords: [],
        locationAddress: null,
        locationSuburb: capitalizeText(metaData.locality_name),
        locationPostcode: metaData.postcode,
        locationState: metaData.state_territory
      });

      fetch(`https://nominatim.openstreetmap.org/search.php?q=${metaData.locality_name}%2C+${metaData.state_territory}%2C+AU&polygon_geojson=1&format=json`)
        .then(resp => resp.json())
        .then(data => {
          // this.validatePostcode(this.extractPostcode(data)) Temporary disable the postcode validation

          let filterGeoJsonType = data.filter(function(data) {
            return data.geojson.type === "MultiPolygon" || data.geojson.type === "Polygon"
          });

          if (filterGeoJsonType.length > 0) {
            this.setState({ options: filterGeoJsonType });
          } else {
            const coords = { lat: parseFloat(metaData.latitude), lng: parseFloat(metaData.longitude) }
            this.setState({ coords })
          }
        });
    } else {
      let errors = this.state.errors
      this.setState({
        coords: {},
        errors: delete errors['postcode'],
        polygonCoords: [],
        locationAddress: null,
        locationSuburb: null,
        locationPostcode: null,
        locationState: null,
      });
    }
  }

  renderToMaps (selectedOptions) {
    const option = selectedOptions[0]

    if (option.geojson.type === "MultiPolygon"){
      this.renderCoordinate(option.geojson.coordinates[0][0]);
    } else if(option.geojson.type === "Polygon"){
      this.renderCoordinate(option.geojson.coordinates[0]);
    }
  }

  renderContinue() {
    const {
      coords,
      polygonCoords,
      validPostcode,
      loanAmountValid,
    } = this.state

    if (Object.keys(coords).length == 0 && polygonCoords.length == 0) {
      return null;
    } else {
      return(
        <div className='text-center'>
          <ContinueButton
            onClick={ this.onClick  }
            enabled={ (validPostcode && loanAmountValid) }
          />
        </div>
      )
    }
  }

  renderLoanAmount() {
    const { helpText, loanAmount, errors, coords, polygonCoords } = this.state
    const { loanPurpose, loanTarget, hasFoundHome } = this.props

    if (Object.keys(coords).length == 0 && polygonCoords.length == 0) {
      return null;
    } else {
      return (
        <div>
          <LoanAmount
            target={loanTarget}
            finalApplication={ loanPurpose === 'refinance' || hasFoundHome }
            needsRentAmount={ (loanPurpose === 'purchase') && (loanTarget === 'investment') }
            loanAmount={ loanAmount }
            onChange={ this.onLoanAmountChange }
          />
          <br />
        </div>
      )
    }
  }

  needsFullAddress() {
    const { loanPurpose, hasFoundHome } = this.props
    return (loanPurpose === 'refinance' || hasFoundHome)
  }

  title() {
    if (this.needsFullAddress()) {
      return I18n.t('onboarding.loan_location.title.full_address')
    } else {
      return I18n.t('onboarding.loan_location.title.searching')
    }
  }

  render() {
    const { loanAmount, loanPurpose, hasFoundHome } = this.props
    const { coords, polygonCoords, errors, continueEnabled } = this.state

    return (
      <div className='container product container'>
        <h3 className="onboarding-title text-center">
          { this.title() }
        </h3>
        <div className='card card-single'>
          <div className='card-body'>
            { this.needsFullAddress() ?
              <AddressWithMap
                label='Please enter your address'
                size='large'
                onChange={ this.setAddress }
                validateServicedPostcode={ false } // Temporary (default value must be: true)
                postcodeValidationSuccess={ this.postcodeValidationSuccess }
                postcodeValidationFailure={ this.postcodeValidationFailure }
              /> :
              <div>
                <SuburbLookup
                  onChange={ this.setPolygon }
                  errorMessage={ errors['postcode'] }
                />
                <Map
                  coords={ {} }
                  polygonCoords={polygonCoords}
                  zoom={ 13 }
                />
              </div>
            }

            { this.renderLoanAmount() }
          </div>
        </div>
        <div className='card card-invisible'>
          { this.renderContinue() }
          <Back onGoBack={this.props.onGoBack} />
        </div>
        <br/>
        <br/>
      </div>
    )
  }
}

export default LoanLocation;
